class FileUploader {

    constructor($compile, $window, AssetService, $uibModal, $q) {

        return {
            restrict: "E",
            templateUrl: "file-uploader/file-uploader.html",
            scope: {
                folderId: "=",
                files: "=?",
                currentDirectoryListing: "=?"
            },
            link: function($scope, $element, $attributes) {

                $scope.pendingUploads = [];
                $scope.completedUploads = [];
                $scope.canAcceptFiles = true;

                this.$scope = $scope;
                this.$compile = $compile;
                this.AssetService = AssetService;
                this.$window = $window;
                this.$uibModal = $uibModal;

                let allowedTypes = [".ttf", ".otf", ".woff", ".woff2", ".eot", ".svg", "application/x-shockwave-flash", ".js"];

                let showExistsModal = (file) => {

                    var modalInstance = this.$uibModal.open({
                        animation: this.$scope.animationsEnabled,
                        templateUrl: 'components/confirmation-modal.html',
                        controller: 'ConfirmationModalCtrl',
                        resolve: {
                            title: () => file.name + " already exists",
                            message: () => file.name + " already exists and will be replaced. Replacing this asset will affect any live creatives, are you sure you want to do this?",
                        }
                    });

                    modalInstance.result.then(() => {

                    }, () => this.$scope.deletePendingFile(file)); 

                };

                let allowedType = (fileName) => {
                    let allowed = false;
                    allowedTypes.forEach(type => {
                        if(fileName.toLowerCase().indexOf(type) > -1) {
                            allowed = true;
                            return false;
                        }
                    });
                    return allowed;
                };

                if(!!$scope.files) {

                    let acceptAllDupes = false;
                    $.each($scope.files, (ix, file) => {
                        if(/^(image|video|text|javascript)\//.test(file.type) || allowedType(file.name)) {
                            $scope.pendingUploads.push(file);
                            if($scope.currentDirectoryListing.filter(f => file.name == f.name).length > 0) {
                                showExistsModal(file);
                            }
                        }
                        else {
                            $(".completed-uploads").addClass("is-bad-file");
                            $window.setTimeout(function(){
                                $(".completed-uploads").removeClass("is-bad-file");
                            }, 500);
                        }
                    });
                }

                let isDropAllowed = (tx) => {
                    var isAllowed = false;
                    if(tx) {
                        $.each(tx.files, function(ix, item) {
                            if(item.kind == "file") {
                                isAllowed = true;
                                return false;
                            }
                        });
                    }
                    return isAllowed;
                };

                let addFilesToUploadList = (files) => {
                
                    $.each(files, (ix, file) => {
                        
                        var existing = false;
                        $.each($scope.pendingUploads, (ix, pending) => {
                            if(pending.name == file.name) {
                                existing = true;
                            } 
                        });

                        if(!existing) {
                            file.isUploading = false;
                            file.uploadProgress = 0;
                            $scope.pendingUploads.push(file);
                        }
                        else {
                            $("#workarea").addClass("is-bad-file");
                            this.$window.setTimeout(() => { $("#workarea").removeClass("is-bad-file"); }, 400);
                        }
                    });
            
                    $scope.$apply();
                };


                if($window.FileReader) {
                    $element.on("dragenter", (ev) => {
                        ev.stopPropagation();
                        ev.preventDefault();
                        ev.originalEvent.dataTransfer.dropEffect = 'copy';
                        $(".completed-uploads").addClass("is-dragging-file");
                    });

                    $element.on("dragover", function(ev) {
                        ev.stopPropagation();
                        ev.preventDefault();
                        if(!$(".completed-uploads").hasClass("is-dragging-file")) {
                            $(".completed-uploads").addClass("is-dragging-file");
                        }
                    });

                    $element.on("dragleave", function(ev) {
                        ev.stopPropagation();
                        ev.preventDefault();
                        $(".completed-uploads").removeClass("is-dragging-file");
                    });

                    $element.on("drop", (ev) => {
                        
                        ev.stopPropagation();
                        ev.preventDefault();
                        
                        $(".completed-uploads").removeClass("is-dragging-file");
                        
                        let files = [];
                        $.each(ev.originalEvent.dataTransfer.files, (ix, file) => {
                            if(/^(image|video|text)\//.test(file.type) || file.type === "application/x-shockwave-flash" || allowedType(file.name) ) {
                                files.push(file);
                                if(this.$scope.currentDirectoryListing.filter(f => file.name == f.name).length > 0) {
                                    showExistsModal(file);
                                }
                            }
                            else {
                                $(".completed-uploads").addClass("is-bad-file");
                                this.$window.setInterval(() => {
                                    $(".completed-uploads").removeClass("is-bad-file");
                                }, 1000);
                            }
                        });
                        addFilesToUploadList(files);
                            
                    });

                    $scope.deletePendingFile = (file) => {
                        let ix =  this.$scope.pendingUploads.map((f) => { return f.name; }).indexOf(file.name);
                        if(ix >= 0) {
                            this.$scope.pendingUploads.splice(ix, 1);
                        }
                    }; 

                    $scope.deleteAllPendingFiles = () => {
                        this.$scope.pendingUploads = [];
                    };

                    $scope.uploadAllFiles  = () => {
                        $.each(this.$scope.pendingUploads, (ix, file) => {
                            
                            file.isUploading = true;
                            
                            this.AssetService.uploadFile(this.$scope.folderId, file,                        
                                (data) => { // completion callback
                                    file.isUploading = false;
                                    let ix =  this.$scope.pendingUploads.map((f) => { return f.name; }).indexOf(file.name);
                                    if(ix >= 0) {
                                        this.$scope.pendingUploads.splice(ix, 1);
                                        this.$scope.completedUploads.push(file);
                                    }
                                    this.$scope.$root.$broadcast("asset_created", data.data);
                                    this.$scope.$apply();
                                },
                                (status) => { // progress callback
                                    file.uploadProgress = status;
                                    this.$scope.$apply();                           
                                }
                            );
                            
                        });
                    };

                }
    
            }
        };
    }

    deletePendingFile(file) {
        let ix =  this.$scope.pendingUploads.map((f) => { return f.name; }).indexOf(file.name);
        if(ix >= 0) {
            this.$scope.pendingUploads.splice(ix, 1);
        }
    }
}


angular.module('cpm')
    .directive('fileUploader', ['$compile','$window', 'AssetService', '$uibModal', '$q', ($compile, $window, AssetService, $uibModal, $q) => {
        'use strict';
        return new FileUploader($compile, $window, AssetService, $uibModal);
    }]);
